/**
 * @generated SignedSource<<72994ad6fc0e4ac6417fb6af63784821>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LinkedPullRequestsRelease$data = {
  readonly id: string;
  readonly isLatest: boolean;
  readonly isPrerelease: boolean;
  readonly name: string | null | undefined;
  readonly tagName: string;
  readonly url: string;
  readonly " $fragmentType": "LinkedPullRequestsRelease";
};
export type LinkedPullRequestsRelease$key = {
  readonly " $data"?: LinkedPullRequestsRelease$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkedPullRequestsRelease">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "LinkedPullRequestsRelease"
};

(node as any).hash = "01d474334b576ff66ec32af0f02d83d1";

export default node;
